import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const CountryFlagImage = ({ countryCode, className })=>{
    if (!countryCode) return null;
    const imageFile = `${countryCode}.svg`;
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        children: /*#__PURE__*/ _jsx("figure", {
            children: /*#__PURE__*/ _jsx("img", {
                src: `/aid/assets/svg/flags/${imageFile}`,
                alt: countryCode
            })
        })
    });
};
export default CountryFlagImage;
